module.exports = __webpack_public_path__ + "img/part1-2.a06457b9.png";